import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { MyHealthIcon, ArrowForwardIcon } from "../../../assets/icons";
import BlueButton from "../../../components/BlueButton";

interface Props {
  goForward: () => void;
}

const Start = ({ goForward }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.contentContainer}>
        <img src={MyHealthIcon} alt="my-health-icon" />
        <Typography variant="h2">Não estamos sozinhos</Typography>
        <Typography>Visando a saúde e bem estar de todos que acessam as unidades da PepsiCo, recomendamos que acesse o questionário de saúde.</Typography>
      </Box>
      <BlueButton
        dataCy="start-quiz-button"
        action={goForward}
        endIcon={<ArrowForwardIcon />}
      >
        Responder Questionário
      </BlueButton>
    </Box>
  );
}

export default Start;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      minHeight: '70vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',

      [theme.breakpoints.up('sm')]: {
        justifyContent: 'center',
      },
      [theme.breakpoints.up('md')]: {
        minHeight: '40vh',
      },
    },

    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& img': {
        width: '100%',
        height: 'auto',
        maxWidth: 150,
        filter: 'drop-shadow(0px 5px 10px #21212133)'
      },

      '& h2': {
        maxWidth: '65vw',
        marginTop: theme.spacing(4),
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
        textAlign: 'center'
      },

      '& p': {
        marginTop: theme.spacing(1),
        width: "90%",
        maxWidth: '90vw',
        textAlign: 'center',

        [theme.breakpoints.up('sm')]: {
          margin: theme.spacing(1, 0, 6),
          width: "71%",
        },
        [theme.breakpoints.up('lg')]: {
          width: "51%",
        },
      }
    },
  }))